import React, { useState } from 'react';
import './StoreMap.css';

const StoreMap = ({ stores, onStoreSelect, onBackToList }) => {
  const [selectedArea, setSelectedArea] = useState(null);

  // Datos de áreas/barrios
  const areas = [
    {
      name: 'MONSERRAT',
      stores: ['Av. Boedo 1356 | Boedo, CABA', 'lunes a viernes 8 am - 22 PM', 'sabado 9 AM - 21 PM'],
      position: { top: '15%', left: '25%' }
    },
    {
      name: 'VILLA CRESPO',
      stores: ['Milan 14 | Crespo, CABA', 'lunes a viernes 7 AM - 23 PM', 'sabado 8 AM - 1 AM'],
      position: { top: '35%', left: '40%' }
    },
    {
      name: 'CABALLITO',
      stores: ['Av. Rivadavia 2381 | Caballito, CABA', 'lunes a viernes 8 am - 22 PM', 'sabado 9 AM - 21 PM'],
      position: { top: '50%', left: '50%' }
    },
    {
      name: 'PALERMO',
      stores: ['Serrano 1382 | Palermoo, CABA', 'lunes a viernes 9 AM - 00 AM', 'sabado 8 AM' , 'domingo 8 AM - 22 PM'],
      position: { top: '25%', left: '60%' }
    },
    {
      name: 'BALVANERA',
      stores: ['Abasto Shopping', 'Av. Díaz Vélez'],
      position: { top: '60%', left: '55%' }
    }
  ];

  return (
    <div className="store-map">
      <div className="map-container">
        {/* Mapa simplificado - en una app real usarías Google Maps o similar */}
        <div className="simplified-map">
          {areas.map(area => (
            <div
              key={area.name}
              className={`map-area ${selectedArea === area.name ? 'selected' : ''}`}
              style={area.position}
              onClick={() => setSelectedArea(area.name)}
            >
              <div className="area-marker"></div>
              <div className="area-info">
                <h4>{area.name}</h4>
                {selectedArea === area.name && (
                  <div className="area-details">
                    {area.stores.map((store, index) => (
                      <p key={index}>{store}</p>
                    ))}
                    <button 
                      className="select-store-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        // Encontrar la tienda correspondiente al área
                        const store = stores.find(s => 
                          area.name.toLowerCase().includes(s.name.toLowerCase().split(' ')[0])
                        );
                        if (store) onStoreSelect(store);
                      }}
                    >
                      Elegir tienda
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="closest-branches">
        <h3>Tiendas cerca a tu ubicación</h3>
        {stores.slice(0, 3).map(store => (
          <div 
            key={store.id} 
            className="branch-card"
            onClick={() => onStoreSelect(store)}
          >
            <h4>{store.name}</h4>
            <p>{store.address}</p>
          </div>
        ))}
      </div>

      <button className="back-to-list-btn" onClick={onBackToList}>
        Atras a lista
      </button>
    </div>
  );
};

export default StoreMap;